<template>
  <div class="dropdown more-filters float-right btn-group" role="group" aria-expanded="false" ref='dropdown' v-click-outside='closeDropdown'>
    <button @click='showFilter = null' class="btn btn-neutral" type="button" data-toggle="dropdown">
      {{ $t('root.filters.more_filters') }}
    </button>

    <div class="dropdown-menu">
      <div v-show='!showFilter'>
        <input v-model='q' type="search" class="form-control" />

        <ul>
          <li v-for='(name, filter) in filteredFilterList' :key='filter' @click='showFilter = filter' class="dropdown-item">
            {{ name }}
          </li>
        </ul>
      </div>

      <component v-if='showFilter' :is="'filter-items-by-' + showFilter" :folder='folder' @cancel='showFilter = null' />
    </div>
  </div>
</template>

<script>
  import _filter_items_by_shared from './_filter_by_shared'
  import _filter_items_by_star from './_filter_by_star'
  import _filter_items_by_subscription from './_filter_by_subscription'
  import _filter_items_by_progress from './_filter_by_progress'
  import _filter_items_by_tag from './_filter_by_tag'

  export default {
    components: {
      'filter-items-by-progress': _filter_items_by_progress,
      'filter-items-by-shared': _filter_items_by_shared,
      'filter-items-by-star': _filter_items_by_star,
      'filter-items-by-subscription': _filter_items_by_subscription,
      'filter-items-by-tag': _filter_items_by_tag,
    },
    props: {
      folder: {
        type: Object,
        default: () => { return {} },
      },
    },
    mounted() {
      $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
        if (!this.isClosable)
          return false

        this.isClosable = false
        return true
      })
    },
    data() {
      return {
        q: '',
        showFilter: null,
        isClosable: false,
      }
    },
    computed: {
      upperQ() {
        return this.q.toUpperCase()
      },
      filterList() {
        return {
          progress: this.$t('root.filters.checklist_progress'),
          shared: this.$t('root.filters.shared_status'),
          star: this.$t('root.filters.star_status'),
          subscription: this.$t('root.filters.subscribed'),
          tag: this.$t('root.filters.tags'),
        }
      },
      filteredFilterList() {
        if (this.q.length < 1)
          return this.filterList

        const fs = {}
        Object.keys(this.filterList).forEach((k) => {
          const v = this.filterList[k]

          if (v.toUpperCase().indexOf(this.upperQ) >= 0)
            fs[k] = v
        })
        return fs
      },
    },
    methods: {
      closeDropdown() {
        if (this.$refs.dropdown.classList.contains('show'))
          this.isClosable = true
      },
    }
  }
</script>
<style lang="sass" scoped>
  .dropdown-menu
    padding: 10px
    .dropdown-item
      cursor: pointer
  .more-filters
    position: relative
    .btn.btn-neutral
      border-radius: 3px
    .dropdown-menu
      transform: none!important
      top: 45px!important
</style>
